import { take, call, put, fork } from 'redux-saga/effects';
import {
  fetchEventList,
  successFetchEventList,
  failFetchEventList,
} from '../actions/event';
import superFetch from '../modules/superFetch';

export function* handleFetchEventList() {
  while (true) {
    yield take(`${fetchEventList}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/event',
      type: 'GET',
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(successFetchEventList(Object.assign({}, payload)));
      continue;
    }
    yield put(failFetchEventList(String(err)));
  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleFetchEventList);
}



// WEBPACK FOOTER //
// ./src/sagas/event.js